import ReconcileDashboard from '../ReconcileDashboard';

const ReconcilePanel = () => {
  return (
    <div>
      <ReconcileDashboard />
    </div>
  );
};

export default ReconcilePanel;
